// oxlint-disable-next-line no-unassigned-import
import '@fontsource/roboto'
// oxlint-disable-next-line no-unassigned-import
import './index.css'
// TODO(pascal): Actually create the store in the App, not here.
// oxlint-disable-next-line no-unassigned-import
import '@store/store'

import EnvConfigProvider from '@contexts/EnvConfigProvider'
import store from '@store/store'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import App from './App'

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById('root')!)

root.render(
	<React.StrictMode>
		<Provider store={store}>
			<EnvConfigProvider>
				<App />
			</EnvConfigProvider>
		</Provider>
	</React.StrictMode>
)
